import React from "react";
import ZoomSettings from "./zoom";
import AddCategoryForm from "./AddCategoryForm";
import ItemInfo from "./itemInfo";
import ModifyData from "./modifyData";

function ZoomAndCategory() {
    return (
        <div>
        <div>
                <ZoomSettings/>
                <AddCategoryForm />
                <ItemInfo />
                <ModifyData />
              </div>
        </div>
    )
}

export default ZoomAndCategory